import { useCallback, useState } from 'react'
import { useIntake } from './useIntakeContext'
import debounce from 'lodash/debounce'

export const useFormDebounce = (debounceTimeout = 1500) => {
  const { updateUser, setIntakeState } = useIntake()
  const [loading, setLoading] = useState(false)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedUserUpdate = useCallback(
    debounce(async (updatedIntakeState) => {
      updateUser(updatedIntakeState)
      setLoading(false)
    }, debounceTimeout), // Adjust the debounce delay as needed
    []
  )

  // old method fot updateIntakeState and submit not working after splitting the intake update into multiple queries
  const updateIntakeStateAndSubmit = useCallback(
    (updateFunction) => {
      const mynewfunc = async (intakeUpdates) => {
        setLoading(true)
        const newState = await updateFunction(intakeUpdates)
        // console.log(newState)
        debouncedUserUpdate(newState)
      }
      return mynewfunc
    },
    [debouncedUserUpdate]
  )

  const onBlurWithValidation = ({ originalValue, runValidation, submit }) => {
    return (e) => {
      const newValue = e.target.value
      if (newValue === originalValue) return
      if (runValidation) {
        e.target.dispatchEvent(new FocusEvent('blur', { bubbles: true }))
      }
      submit(newValue)
    }
  }

  // Changeing method back after replacing user update setup
  // const updateIntakeStateAndSubmit = useCallback(
  //   (updateFunction, operationType) => {
  //     return async (intakeUpdates) => {
  //       setLoading(true)

  //       // Call updateFunction and manually merge state
  //       updateFunction(intakeUpdates)

  //       // Ensure we get the latest state after update
  //       setIntakeState((prevState) => {
  //         const newState = { ...prevState }
  //         debouncedUserUpdate(newState, operationType)
  //         return newState
  //       })
  //     }
  //   },
  //   [debouncedUserUpdate]
  // )

  return {
    debouncedUserUpdate,
    updateIntakeStateAndSubmit,
    loading,
    onBlurWithValidation,
  }
}
